/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-07-02T16:29:31.199
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listReportFinancialRentContractDetailCollectionMonth,
	listReportFinancialRentContractDetailCollectionMonthInit,
	listReportFinancialRentContractDetailCollectionMonthByAuthorizations,
	deleteReportFinancialRentContractDetailCollectionMonth
	
} from '@api/report/ReportFinancialRentContractDetailCollectionMonth';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listReportFinancialRentContractDetailCollectionMonth({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportFinancialRentContractDetailCollectionMonth(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportFinancialRentContractDetailCollectionMonthByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportFinancialRentContractDetailCollectionMonthByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportFinancialRentContractDetailCollectionMonthInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportFinancialRentContractDetailCollectionMonthInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteReportFinancialRentContractDetailCollectionMonth({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteReportFinancialRentContractDetailCollectionMonth({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
